module.exports = __webpack_public_path__ + "img/yellow.89d567dd.svg";